<template>
  <main class="main-container">
    <TopBar></TopBar>
    <ActionTiles></ActionTiles>
    <ActionCards></ActionCards>
    <TextForms></TextForms>
    <Alerts></Alerts>
    <Buttons></Buttons>
    <Card></Card>
    <Dropdowns></Dropdowns>
    <Modal></Modal>
    <Breadcrumb></Breadcrumb>
    <Progress></Progress>
    <Table></Table>
    <Matrix></Matrix>
    <DatePicker></DatePicker>
    <State></State>
  </main>
</template>

<script>
    import ActionTiles from '@/components/ActionTiles'
    import ActionCards from '@/components/ActionCards'
    import TextForms from '@/components/TextForms'
    import TopBar from '@/components/TopBar'
    import Alerts from '@/components/Alerts'
    import Buttons from '@/components/Buttons'
    import Card from '@/components/Card'
    import Dropdowns from '@/components/Dropdowns'
    import Modal from '@/components/Modal'
    import Breadcrumb from '@/components/Breadcrumb'
    import Progress from '@/components/Progress'
    import Table from '@/components/table'
    import Matrix from '@/components/Matrix'
    import DatePicker from '@/components/datepicker'
    import State from '@/components/Statistics'
    export default {
        name: 'StyleGuide',
        components: {
            'ActionTiles': ActionTiles,
            'ActionCards': ActionCards,
            'TextForms': TextForms,
            'TopBar': TopBar,
            Alerts,
            Buttons,
            Card,
            Dropdowns,
            Modal,
            Breadcrumb,
            Progress,
            Table,
            Matrix,
            DatePicker,
            State
        },
        data () {
          return {
            msg: 'Welcome to Your Vue.js App'
          }
        }
    }
</script>

<style lang="scss">
  @import "./../assets/scss/_base.scss";
</style>



// WEBPACK FOOTER //
// src/components/StyleGuide.vue